export const verifyApiResponse = (response) => {
  if (response.status === 200) {
    return response.data;
  } else {
    return {
      sytemMessage: {
        success: false,
        code: response.status,
        message: response.message,
      },
    };
  }
};
